module.exports = __webpack_public_path__ + "static/media/Roast_Onion.b5735765.webp";